(function () {
  const variantColorFromTitle = (title) => {
    if (!title) return null;
    const t = title.toLowerCase();
    if (t.includes('black')) return 'black';
    return 'chrome';
  };

  const syncGallery = (gallery, color) => {
    if (!gallery || !color) return;
    gallery.setAttribute('data-active-color', color);

    const slider = gallery.querySelector('.slider');
    const firstVisible = gallery.querySelector(
      `.product__media-item[data-variant-color="${color}"], .product__media-item:not([data-variant-color])`
    );
    if (slider && firstVisible) {
      slider.scrollTo({ left: firstVisible.offsetLeft - slider.offsetLeft, behavior: 'auto' });
    }

    gallery.querySelectorAll('slider-component').forEach((sc) => {
      if (typeof sc.initPages === 'function') sc.initPages();
    });

    gallery.querySelectorAll('.slider-dot').forEach((d) => d.classList.remove('is-active'));
    const firstVisibleDot = gallery.querySelector(
      `.slider-dot[data-variant-color="${color}"], .slider-dot:not([data-variant-color])`
    );
    if (firstVisibleDot) firstVisibleDot.classList.add('is-active');
  };

  const init = () => {
    const galleries = document.querySelectorAll('media-gallery[data-active-color]');
    if (!galleries.length) return;

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      requestAnimationFrame(init);
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event && event.data && event.data.variant;
      const color = variantColorFromTitle(variant && variant.title);
      if (!color) return;
      galleries.forEach((g) => syncGallery(g, color));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
